import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import Error from '@/components/Error';
import Terms from '@/components/Terms';
import Home from '@/components/home/Home';
import Winners from '@/components/Winners';
import Store from '@/components/home/Store';
import Index from '@/components/visitor/Index';
import Game from '@/components/home/game/Game';
import Login from '@/components/visitor/Login';
import HowItWorks from '@/components/HowItWorks';
import Prizes from '@/components/visitor/Prizes';
import Visitor from '@/components/visitor/Visitor';
import Profile from '@/components/home/profile/Profile';
import SignUp3 from '@/components/visitor/signup/SignUp3';
import SignUp2 from '@/components/visitor/signup/SignUp2';
import TwoStepRegistration2 from '@/components/visitor/signup/TwoStepRegistration2';
import TwoStepRegistration1 from '@/components/visitor/signup/TwoStepRegistration1';
import RoundEnded from '@/components/home/game/RoundEnded';
import Notifications from '@/components/home/Notifications';
import SelectTheme from '@/components/home/game/SelectTheme';
import ResumingGame from '@/components/home/game/ResumingGame';
import ProfileEdit from '@/components/home/profile/ProfileEdit';
import SelectedTheme from '@/components/home/game/SelectedTheme';
import OpponentFound from '@/components/home/game/OpponentFound';
import HomeDefaultContent from '@/components/home/DefaultContent';
import HowItWorksLoggedIn from '@/components/home/HowItWorksLoggedIn';
import SearchingOpponent from '@/components/home/game/SearchingOpponent';
import ForgotPassword1 from '@/components/visitor/forgotPassword/ForgotPassword1';
import ForgotPassword2 from '@/components/visitor/forgotPassword/ForgotPassword2';
import ForgotPassword3 from '@/components/visitor/forgotPassword/ForgotPassword3';
import TwoStepForgotPassword1 from '@/components/visitor/forgotPassword/TwoStepForgotPassword1';
import TwoStepForgotPassword2 from '@/components/visitor/forgotPassword/TwoStepForgotPassword2';
import ProfileDefaultContent from '@/components/home/profile/DefaultContentProfile';
import RegisterViaSms from '../components/visitor/signup/RegisterViaSms';
import SignUp1SingleCountry from '@/components/visitor/signup/SignUp1SingleCountry';
import PrizesAndLeaderboards from '@/components/home/prizesAndLeaderboards/PrizesAndLeaderboards';
import GetStartedFreePlay from '@/components/visitor/freeTrial/GetStartedFreePlay';
import FreePlayIndex from '@/components/visitor/freeTrial/Index';
import SearchingOpponentFreePlay from '@/components/visitor/freeTrial/SearchingOpponentFreePlay';
import OpponentFoundFreePlay from '@/components/visitor/freeTrial/OpponentFoundFreePlay';
import SelectThemeFreePlay from '@/components/visitor/freeTrial/SelectThemeFreePlay';
import SelectedThemeFreePlay from '@/components/visitor/freeTrial/SelectedThemeFreePlay';
import GameFreePlay from '@/components/visitor/freeTrial/GameFreePlay';
import NewGameFreePlay from '@/components/visitor/freeTrial/NewGameFreePlay';
import RoundEndedFreePlay from '@/components/visitor/freeTrial/RoundEndedFreePlay';
import Version from '@/components/Version';
import AddOnGameLatern from '@/components/home/game/addongamelanterns/AddOnGameLantern';
import Register2subscribe from '@/components/visitor/signup/Register2subscribe';
import FavoriteUsers from '@/components/home/users/FavoriteUsersScreen';
import OtherUserProfile from '@/components/home/users/OtherUserProfile';
import BlockedUsers from '@/components/home/profile/BlockedUsers';
import PendingRequest from '@/components/home/game/challenge/PendingRequest';
import Achievements from '@/components/home/achievements/Achievements';
import AddOnGame from '@/components/home/game/addongame/AddOnGame';
import PostGameAddOn from '@/components/home/game/addongame/PostGameAddOn';
import AddOnGamePuzzle from '@/components/home/game/addongamepuzzle/AddOnGamePuzzle';

Vue.use(Router);

// EXC-2781
const LoginAndForgotPasswordPageNavigationGuard = (to, from, next) => {
  if (store.getters['common/existThisPathInForbiddenPages'](to.path)) {
    next({ path: '/' });
  } else {
    next();
  }
};

// EXC-1705
const PrizesAndLeaderBoardNavigationGuard = (to, from, next) => {
  if (store.state.common.hideLeaderboard) {
    next({ path: '/' });
  } else {
    next();
  }
};

const AchievementsNavigationGuard = (to, from, next) => {
  if (store.state.common.hideUserAchievements) {
    next({ path: '/' });
  } else {
    next();
  }
}

const prizesNavigationGuard = (to, from, next) => {
  if (store.state.common.hidePrizePage) {
    next({ path: '/' });
  } else {
    next();
  }
};

const getOrNotMessagingComponent = (componentName) => {
  if (store.state.common.messaging.messagingEnabled) {
    return import(/* webpackChunkName: "[request]" */ `@/components/home/chat/${componentName}.vue`);
  }
  return null;
};

// this navigation guard is used when the user is in any page under the home path
// such as ...?#/home/store and tries to enter a game component's url explicitly such as ...?#/game
const gameNavigationGuard = (to, from, next) => {
  if (from.path.includes('home')) {
    next(false);
  } else {
    next();
  }
};

const gameNavigationGuardForRematchHomeOrRoundEnded = (to, from, next) => {
  if ((from.path.includes('home') || from.path.includes('roundEnded')) && store.state.game.validRedirectionToPendingRequestPage) {
    next();
  } else {
    next('/');
  }
};

const gameNavigationGuardForRematch = (to, from, next) => {
  if (from.path.includes('home')) {
    next(store.state.game.transitionOnlyForSearchingToOpponent);
  } else {
    next();
  }
};

const freeTrialGameAccessGuard = (to, from, next) => {
  if (from.path.includes('trial')) next();
  else next('/');
};

const registerViaSmsNavigationGuard = (to, from, next) => {
  if (store.getters['common/isRegistrationViaSms']) {
    next()
  } else {
    next({path: '/'})
  }
}

const twoStepRegistration = (to, from, next) => {
  if(store.getters['common/isRegistrationViaSms']) {
    next({ name: 'registerViaSMS', replace: true })
  } else if (store.getters['common/getTwoStepsRegistration']) {
    // eslint-disable-next-line
    if (to.path === '/register1') {
      next({ path: '/twostepregister1' });
    } else if (to.path === '/register2') {
      next({ path: '/twostepregister2' });
    } else {
      // eslint-disable-next-line
      if (!store.getters['common/existThisPathInForbiddenPages'](to.path)) next();
      else next({ path: '/' });
    }
  } else {
    // eslint-disable-next-line
    if (!store.getters['common/existThisPathInForbiddenPages'](to.path)
      && to.path !== '/twostepregister1' && to.path !== '/twostepregister2') {
      next();
    } else next({ path: '/' });
  }
};

const twoStepForgotPassword = (to, from, next) => {
  const flowName = store.getters['common/getSimpleRegistration'];
  // eslint-disable-next-line
  const forbiddenRoutes = store.getters['common/getAvailableFlowsInfo'][flowName].blockedRoutes;
  let finalDestination;
  if (store.getters['common/getTwoStepsRegistration']) {
    switch (to.path) {
    case '/forgotPassword1': finalDestination = '/twostepforgotPassword1';
      break;
    case '/forgotPassword2': finalDestination = '/twostepforgotPassword2';
      break;
    case '/home/profile/forgotPassword1': finalDestination = '/home/profile/twostepforgotPassword1';
      break;
    case '/home/profile/forgotPassword2': finalDestination = '/home/profile/twostepforgotPassword2';
      break;
    default: break;
    }
    if (finalDestination && !forbiddenRoutes.includes(finalDestination)) {
      next({ path: finalDestination });
    } else if (!forbiddenRoutes.includes(to.path)) {
      next();
    } else {
      next({ path: '/' });
    }
  } else {
    // eslint-disable-next-line
    if (!store.getters['common/existThisPathInForbiddenPages'](to.path)) next();
    else next({ path: '/' });
  }
};

const twoStepForgotPassword2 = (to, from, next) => {
  if (store.getters['common/getTwoStepsRegistration']) {
    if (!store.getters['common/existThisPathInForbiddenPages'](to.path)) next();
    else next({ path: '/' });
  } else {
    next({ path: '/' });
  }
};

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Visitor,
      meta: { requiresAuth: false },
      children: [
        {
          path: '',
          component: Index,
          name: 'index',
        },
        {
          path: 'prizes',
          component: Prizes,
          name: 'prizes',
          beforeEnter: prizesNavigationGuard,
        },
        {
          path: 'winners',
          component: Winners,
          name: 'winners',
        },
        {
          path: 'terms',
          component: Terms,
          name: 'terms',
        },
        {
          path: 'howItWorks',
          component: HowItWorks,
          name: 'howItWorks',
        },
        {
          path: 'registerViaSMS',
          component: RegisterViaSms,
          name: 'registerViaSMS',
          beforeEnter: registerViaSmsNavigationGuard,
        },
        {
          path: 'register1',
          component: SignUp1SingleCountry,
          name: 'register1',
          beforeEnter: twoStepRegistration,
        },
        {
          path: 'register2',
          component: SignUp2,
          name: 'register2',
          beforeEnter: twoStepRegistration,
        },
        {
          path: 'register2subscribe',
          component: Register2subscribe,
          name: 'register2subscribe',
        },
        {
          path: 'register3',
          component: SignUp3,
          name: 'register3',
          beforeEnter: twoStepRegistration,
        },
        {
          path: 'twostepregister1',
          component: TwoStepRegistration1,
          name: 'twoStepRegister1',
          beforeEnter: twoStepRegistration,
        },
        {
          path: 'twostepregister2',
          name: 'twoStepRegister2',
          component: TwoStepRegistration2,
          beforeEnter: twoStepRegistration,
        },
        {
          path: 'login',
          name: 'login',
          component: Login,
          beforeEnter: LoginAndForgotPasswordPageNavigationGuard,
        },
        {
          path: 'forgotPassword1',
          component: ForgotPassword1,
          name: 'forgotPassword1',
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'forgotPassword2',
          component: ForgotPassword2,
          name: 'forgotPassword2',
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'forgotPassword3',
          component: ForgotPassword3,
          name: 'forgotPassword3',
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'twostepforgotPassword1',
          name: 'twoStepForgotPassword1',
          component: TwoStepForgotPassword1,
          beforeEnter: twoStepForgotPassword,
        },
        {
          path: 'twostepforgotPassword2',
          name: 'twoStepForgotPassword2',
          component: TwoStepForgotPassword2,
          beforeEnter: twoStepForgotPassword2,
        },
      ],
    },
    {
      // path: '/home/:id',
      path: '/home',
      component: Home,
      // a meta field
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          component: HomeDefaultContent,
          name: 'homeDefault',
        },
        {
          path: 'notifications',
          component: Notifications,
          name: 'notifications',
        },
        {
          path: 'profile',
          component: Profile,
          children: [
            {
              path: '',
              component: ProfileDefaultContent,
              name: 'profileDefault',
            },
            {
              path: 'edit',
              component: ProfileEdit,
              name: 'edit',
              meta: { displayBackButton: true },
            },
            {
              path: 'forgotPassword1',
              component: ForgotPassword1,
              name: 'profileForgotPassword1',
              beforeEnter: twoStepForgotPassword,
            },
            {
              path: 'forgotPassword2',
              component: ForgotPassword2,
              name: 'profileForgotPassword2',
              beforeEnter: twoStepForgotPassword,
            },
            {
              path: 'forgotPassword3',
              component: ForgotPassword3,
              name: 'profileForgotPassword3',
              beforeEnter: twoStepForgotPassword,
            },
            {
              path: 'twostepforgotPassword1',
              name: 'profileTwoStepForgotPassword1',
              component: TwoStepForgotPassword1,
              beforeEnter: LoginAndForgotPasswordPageNavigationGuard,
            },
            {
              path: 'twostepforgotPassword2',
              name: 'profileTwoStepForgotPassword2',
              component: TwoStepForgotPassword2,
              beforeEnter: LoginAndForgotPasswordPageNavigationGuard,
            },
          ],
        },
        {
          path: 'blockedUsers',
          component: BlockedUsers,
          name: 'blocked-users',
          meta: { requiresAuth: true },
        },
        {
          path: 'prizesAndLeaderBoards',
          component: PrizesAndLeaderboards,
          name: 'prizesAndLeaderBoards',
          beforeEnter: PrizesAndLeaderBoardNavigationGuard,
        },
        {
          path: 'addOnGameLantern',
          component: AddOnGameLatern,
          name: 'addOnGameLantern',
          meta: { requiresAuth: true },
        },
        {
          path: 'addOnGamePuzzle',
          component: AddOnGamePuzzle,
          name: 'addOnGamePuzzle',
          meta: { requiresAuth: true },
        },
        {
          path: 'store',
          component: Store,
          name: 'store',
          meta: { displayBackButton: true },
        },
        {
          path: 'winners',
          component: Winners,
          name: 'winnersHome',
          meta: { requiresAuth: true },
        },
        {
          path: 'howitworksLoggedIn',
          name: 'howItWorksLoggedIn',
          component: HowItWorksLoggedIn,
        },
        {
          path: 'terms',
          component: Terms,
          name: 'termsHome',
          meta: { requiresAuth: true },
        },
        {
          path: 'favoriteUsers',
          component: FavoriteUsers,
          name: 'favorite-users',
          meta: { requiresAuth: true, hasHomeClass: true },
        },
        {
          path: 'chatHistory',
          component: () => getOrNotMessagingComponent('ChatHistory'),
          name: 'chat-history',
          meta: { requiresAuth: true, hasHomeClass: true },
        },
        {
          path: 'newChat',
          component: () => getOrNotMessagingComponent('NewChat'),
          name: 'new-chat',
          meta: { requiresAuth: true, hasHomeClass: true },
        },
        {
          path: 'chat',
          component: () => getOrNotMessagingComponent('ChatScreen'),
          name: 'chat',
          meta: { requiresAuth: true, hasHomeClass: true, hideHeader: false },
        },
        {
          path: 'otherUserProfile',
          component: OtherUserProfile,
          name: 'other-user-profile',
          meta: { requiresAuth: true, hasHomeClass: false },
        },
        {
          path: 'achievements',
          component: Achievements,
          name: 'achievements',
          meta: { requiresAuth: true, hasHomeClass: true },
          beforeEnter: AchievementsNavigationGuard
        },
      ],
    },
    {
      path: '/trial',
      component: FreePlayIndex,
      meta: { requiresAuth: false },
      children: [
        {
          path: '',
          component: GetStartedFreePlay,
          name: 'getStartedFreePlay',
        },
        {
          path: 'searchingOpponent',
          component: SearchingOpponentFreePlay,
          name: 'searchingOpponentFreePlay',
          beforeEnter: freeTrialGameAccessGuard,
        },
        {
          path: 'opponentFound',
          component: OpponentFoundFreePlay,
          name: 'opponentFoundFreePlay',
          beforeEnter: freeTrialGameAccessGuard,
        },
        {
          path: 'selectTheme',
          component: SelectThemeFreePlay,
          name: 'selectThemeFreePlay',
          beforeEnter: freeTrialGameAccessGuard,
        },
        {
          path: 'selectedTheme',
          component: SelectedThemeFreePlay,
          name: 'selectedThemeFreePlay',
          beforeEnter: freeTrialGameAccessGuard,
        },
        {
          path: 'game',
          component: GameFreePlay,
          name: 'gameFreePlay',
          beforeEnter: freeTrialGameAccessGuard,
        },
        {
          path: 'newGame',
          component: NewGameFreePlay,
          name: 'newGameFreePlay',
          beforeEnter: freeTrialGameAccessGuard,
        },
        {
          path: 'roundEnded',
          component: RoundEndedFreePlay,
          name: 'roundEndedFreePlay',
          beforeEnter: freeTrialGameAccessGuard,
        },
      ],
    },
    {
      path: '/postGameAddOn',
      component: PostGameAddOn,
      name: 'postGameAddOn',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuard,
    },
    {
      path: '/searchingOpponent',
      component: SearchingOpponent,
      name: 'searchingOpponent',
      meta: { requiresAuth: true },
    },
    {
      path: '/pendingRequest',
      component: PendingRequest,
      name: 'pendingRequest',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuardForRematchHomeOrRoundEnded,
    },
    {
      path: '/opponentFound',
      component: OpponentFound,
      name: 'opponentFound',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuardForRematch,
    },
    {
      path: '/selectTheme',
      component: SelectTheme,
      name: 'selectTheme',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuard,
    },
    {
      path: '/selectedTheme',
      component: SelectedTheme,
      name: 'selectedTheme',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuard,
    },
    {
      path: '/addOnGame',
      component: AddOnGame,
      name: 'addOnGame',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuard,
    },
    {
      path: '/game',
      component: Game,
      name: 'game',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuard,
    },
    {
      path: '/roundEnded',
      component: RoundEnded,
      name: 'roundEnded',
      meta: { requiresAuth: true },
      beforeEnter: gameNavigationGuard,
    },
    {
      path: '/resumingGame',
      component: ResumingGame,
      name: 'resumingGame',
      meta: { requiresAuth: true },
    },
    {
      path: '/version',
      component: Version,
      name: 'Version',
      meta: { requiresAuth: false },
    },
    {
      path: '/error',
      component: Error,
      name: 'error',
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js